import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashFipeComponent } from './dash-fipe.component';
import { NgChartsModule, ThemeService } from 'ng2-charts';



@NgModule({
  declarations: [DashFipeComponent],
  imports: [
    CommonModule,
    NgChartsModule
  ],
  exports:[
    DashFipeComponent
  ],
  providers: [ThemeService]

})
export class DashFipeModule { }
